var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomain2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 61 61",
    width: 61,
    height: 61,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.49 52.35C28.49 53.55 29.55 54.54 30.85 54.54C32.14 54.54 33.21 53.55 33.21 52.35C33.21 52.01 33.21 49.27 33.21 48.93C34.27 48.24 34.97 47.09 34.97 45.8C34.97 43.68 33.13 41.97 30.85 41.97C28.57 41.97 26.72 43.68 26.72 45.8C26.72 47.09 27.42 48.24 28.49 48.93C28.49 49.61 28.49 52.01 28.49 52.35ZM33.79 45.8C33.79 46.68 33.32 47.52 32.53 48.03C32.5 48.06 32.33 48.16 32.03 48.36L32.03 48.93C32.03 50.98 32.03 52.12 32.03 52.35C32.03 52.95 31.5 53.44 30.85 53.44C30.2 53.44 29.67 52.95 29.67 52.35C29.67 52.12 29.67 50.98 29.67 48.93L29.67 48.36C29.37 48.16 29.2 48.05 29.16 48.03C28.37 47.52 27.9 46.68 27.9 45.8C27.9 44.29 29.22 43.06 30.85 43.06C32.47 43.06 33.79 44.29 33.79 45.8Z",
    id: "ba5dYATKF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44 60L53.25 60L53.25 28.31L8.44 28.31L8.44 60ZM10.8 32.69L16.7 32.69L14.34 39.24L9.62 39.24L9.62 35.96L10.8 32.69ZM36.74 39.24L39.1 32.69L45 32.69L42.64 39.24L36.74 39.24ZM52.07 32.69L49.71 39.24L43.82 39.24L46.18 32.69L52.07 32.69ZM29.67 39.24L32.03 32.69L37.92 32.69L35.56 39.24L29.67 39.24ZM22.59 39.24L24.95 32.69L30.85 32.69L28.49 39.24L22.59 39.24ZM15.52 39.24L17.88 32.69L23.77 32.69L21.41 39.24L15.52 39.24ZM9.62 58.91L9.62 40.33L52.07 40.33L52.07 58.91L9.62 58.91ZM50.89 39.24L52.07 35.96L52.07 39.24L50.89 39.24ZM9.62 29.41L52.07 29.41L52.07 31.59L9.62 31.59L9.62 29.41Z",
    id: "diw9k82NZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38 8.19C20.89 4.13 26.88 2.09 30.85 2.09C40.6 2.09 48.53 9.44 48.53 18.48C48.53 19.06 48.53 21.98 48.53 27.22L49.71 27.22C49.71 21.98 49.71 19.06 49.71 18.48C49.71 8.83 41.27 1 30.85 1C20.43 1 11.98 8.83 11.98 18.48C11.98 19.06 11.98 21.98 11.98 27.22L13.16 27.22L13.16 18.48C13.72 14.22 15.13 10.79 17.38 8.19Z",
    id: "a4IdUgxGtG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.82 18.48C43.82 11.85 38 6.46 30.85 6.46C23.7 6.46 17.88 11.85 17.88 18.48C17.88 19.06 17.88 21.98 17.88 27.22L19.06 27.22C19.06 21.98 19.06 19.06 19.06 18.48C19.06 12.45 24.34 7.56 30.85 7.56C37.36 7.56 42.64 12.45 42.64 18.48C42.64 19.06 42.64 21.98 42.64 27.22L43.82 27.22C43.82 21.98 43.82 19.06 43.82 18.48Z",
    id: "a4pww572xU"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ba5dYATKF",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ba5dYATKF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#diw9k82NZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#diw9k82NZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4IdUgxGtG",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4IdUgxGtG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4pww572xU",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4pww572xU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain2);
export default __webpack_public_path__ + "static/media/domain-2.aaa98733a009145860e1b1e4b16bab3c.svg";
export { ForwardRef as ReactComponent };